import cn from 'classnames';

import { IConDefaultType } from '../types';

export enum BadgeIconVariant {
  ORIGINAL = 'original',
  CONTEST = 'contest',
  BUBBLE_VERSE = 'bubble_verse',
  BUBBLEUP = 'bubbleup',
  BUBBLEUP_CIRCLE = 'bubbleup_circle',
}

export interface IBadgeIconProps extends IConDefaultType {
  variant?: BadgeIconVariant;
}

function BadgeIcon({
  color,
  className,
  size = 26,
  rotate,
  flip,
  variant = BadgeIconVariant.ORIGINAL,
}: IBadgeIconProps) {
  return (
    <i
      className={cn('dds-icon', className, { flip })}
      style={{
        width: size,
        minWidth: size,
        height: size,
        transform: `rotate(${rotate}deg)`,
      }}
    >
      {variant === BadgeIconVariant.ORIGINAL && (
        <svg viewBox="0 0 26 26" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M0 0H26V15C26 21.0751 21.0751 26 15 26H0V0Z" fill="#00C3DD" />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M13 4C8.03745 4 4 8.03738 4 12.9998C4 15.0448 4.67009 16.9724 5.93807 18.5759C6.21889 19.041 6.2152 19.1332 5.93562 20.548L5.88984 20.7803C5.85481 20.9536 5.85481 20.976 5.85481 21.007C5.85481 21.3692 6.14946 21.6639 6.51169 21.6639C6.61277 21.6639 6.71847 21.6295 6.7793 21.6055L6.77961 21.6064C6.95258 21.5321 7.11143 21.4617 7.2589 21.3963C7.92592 21.1007 8.27955 20.9526 8.57789 20.9526C8.6974 20.9526 8.80801 20.9766 8.9263 21.0242C10.1989 21.6716 11.5695 22 13 22C17.9626 22 22 17.9623 22 12.9998C22 8.03738 17.9626 4 13 4ZM18.3758 13.0361C18.3758 13.6553 17.8738 14.1572 17.2547 14.1572C16.6355 14.1572 16.1335 13.6553 16.1335 13.0361C16.1335 12.417 16.6355 11.915 17.2547 11.915C17.8738 11.915 18.3758 12.417 18.3758 13.0361ZM9.86627 13.0361C9.86627 13.6553 9.36431 14.1572 8.74514 14.1572C8.12598 14.1572 7.62402 13.6553 7.62402 13.0361C7.62402 12.417 8.12598 11.915 8.74514 11.915C9.36431 11.915 9.86627 12.417 9.86627 13.0361ZM14.4858 13.4004C14.4858 14.2209 13.8204 14.8862 12.9999 14.8862C12.1794 14.8862 11.5141 14.2209 11.5141 13.4004H14.4858Z"
            fill="white"
          />
        </svg>
      )}
      {variant === BadgeIconVariant.CONTEST && (
        <svg viewBox="0 0 26 26" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M0 0H26V15C26 21.0751 21.0751 26 15 26H0V0Z" fill="#FE008A" />
          <path
            d="M12.4594 4.37584C12.7086 3.87472 13.4286 3.87472 13.6778 4.37584L14.5078 6.04492C14.6067 6.24392 14.798 6.38184 15.0193 6.41375L16.8751 6.6814C17.4323 6.76176 17.6548 7.44137 17.2516 7.83144L15.9087 9.13064C15.7486 9.28554 15.6755 9.50871 15.7133 9.72743L16.0304 11.5619C16.1255 12.1127 15.543 12.5327 15.0447 12.2727L13.3847 11.4066C13.1868 11.3033 12.9504 11.3033 12.7525 11.4066L11.0925 12.2727C10.5942 12.5327 10.0117 12.1127 10.1069 11.5619L10.4239 9.72743C10.4617 9.50871 10.3886 9.28554 10.2285 9.13064L8.88558 7.83144C8.48238 7.44137 8.70487 6.76176 9.26208 6.6814L11.1179 6.41375C11.3392 6.38184 11.5305 6.24392 11.6294 6.04492L12.4594 4.37584Z"
            fill="white"
          />
          <path
            d="M9.89258 14.4079C9.89258 13.9664 10.2532 13.6084 10.6981 13.6084H15.3013C15.7462 13.6084 16.1069 13.9664 16.1069 14.4079V21.0324C16.1069 21.474 15.7462 21.832 15.3013 21.832H10.6981C10.2532 21.832 9.89258 21.474 9.89258 21.0324V14.4079Z"
            fill="white"
          />
          <path
            d="M5.75 16.4624C5.75 16.0209 6.11066 15.6629 6.55556 15.6629H8.0516C8.4965 15.6629 8.85716 16.0209 8.85716 16.4624V21.0311C8.85716 21.4726 8.4965 21.8306 8.0516 21.8306H6.55556C6.11066 21.8306 5.75 21.4726 5.75 21.0311V16.4624Z"
            fill="white"
          />
          <path
            d="M17.1426 16.6315C17.1426 16.19 17.5032 15.832 17.9481 15.832H19.4442C19.8891 15.832 20.2497 16.19 20.2497 16.6315V21.2002C20.2497 21.6417 19.8891 21.9997 19.4442 21.9997H17.9481C17.5032 21.9997 17.1426 21.6417 17.1426 21.2002V16.6315Z"
            fill="white"
          />
        </svg>
      )}
      {variant === BadgeIconVariant.BUBBLE_VERSE && (
        <svg viewBox="0 0 26 26" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M0 0H26V15C26 21.0751 21.0751 26 15 26H0V0Z" fill="#7850C6" />
          <path
            d="M19.3424 11.9364L18.5892 10.7812C18.2 10.191 17.8925 9.48154 17.3213 9.03577C16.7941 8.62766 16.0597 8.33885 15.3881 8.33885H10.3669C9.8083 8.33885 9.23714 8.54604 8.76012 8.8223C8.09481 9.21156 7.74332 9.9022 7.32907 10.5301C7.02152 11.0009 6.71397 11.4655 6.40642 11.9364C5.91685 12.4764 5.86036 13.3993 6.28717 13.9895L10.7121 21.7167C11.0887 22.2441 11.9423 21.9866 11.9423 21.3462L11.9423 16.5888C11.9423 16.1995 11.7729 15.8166 11.459 15.5717C10.9318 15.1573 10.6054 14.5232 10.6368 13.8137C10.687 12.715 11.6159 11.8171 12.7583 11.7606C14.045 11.6979 15.1057 12.6836 15.1057 13.9079C15.1057 14.5797 14.7856 15.1824 14.2772 15.578C13.9822 15.804 13.8002 16.1368 13.8002 16.5009L13.8002 21.3462C13.8002 21.9866 14.6538 22.2378 15.0304 21.7167L19.4553 13.9895C19.8759 13.3993 19.8257 12.4764 19.3298 11.9364H19.3424Z"
            fill="white"
          />
          <path
            d="M7.81927 5.61025C7.31276 4.95273 7.78148 4 8.61147 4L16.9661 4C17.7722 4 18.247 4.90494 17.7889 5.56827L17.1725 6.46077C16.9858 6.73111 16.6782 6.8925 16.3497 6.8925H9.29898C8.98875 6.8925 8.69609 6.74852 8.50678 6.50275L7.81927 5.61025Z"
            fill="white"
          />
        </svg>
      )}
      {variant === BadgeIconVariant.BUBBLEUP && (
        <svg viewBox="0 0 26 26" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M0 0H26V15C26 21.0751 21.0751 26 15 26H0V0Z" fill="#03C975" />
          <path
            clipRule="evenodd"
            fillRule="evenodd"
            d="M17.9541 13.0242L17.7305 16.1801L17.737 16.1866C17.7169 16.4674 17.597 16.7307 17.3917 16.9359L16.5435 17.7842C16.174 18.1536 15.5863 18.1679 15.2344 17.816L13.4204 16.002L12.7213 16.2447C12.3593 16.3704 11.9572 16.2782 11.6862 16.0072L8.74581 13.0667C8.48608 12.807 8.38965 12.4258 8.49464 12.0738L8.72383 11.3054L6.84781 9.42941C6.49592 9.07752 6.51021 8.48979 6.87963 8.12037L7.72792 7.27208C7.92631 7.07369 8.19639 6.94698 8.47722 6.9268L11.6788 6.74886L11.9319 6.49574C14.34 4.08767 18.4667 3.46673 19.8482 4.8482C21.2297 6.22968 20.6221 10.3561 18.2072 12.771L17.9541 13.0242ZM17.3298 10.4986C16.5293 11.2992 15.2313 11.2992 14.4307 10.4986C13.6301 9.69802 13.6301 8.40003 14.4307 7.59945C15.2313 6.79887 16.5293 6.79887 17.3298 7.59945C18.1304 8.40003 18.1304 9.69802 17.3298 10.4986ZM5.79355 19.5168C6.74073 19.6615 8.58614 19.9434 9.40705 19.1225C10.36 18.1696 10.268 16.5283 9.20186 15.4621C8.13575 14.396 6.49445 14.304 5.54152 15.257C4.79762 16.0009 5.02554 18.0978 5.1671 19.0017C5.20703 19.2506 5.41337 19.457 5.66233 19.4969C5.70381 19.5031 5.74762 19.5098 5.79355 19.5168Z"
            fill="white"
          />
        </svg>
      )}
      {variant === BadgeIconVariant.BUBBLEUP_CIRCLE && (
        <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M19.2 9.6C19.2 14.8992 14.8992 19.2 9.6 19.2C4.3008 19.2 0 14.8992 0 9.6C0 4.3008 4.3008 0 9.6 0C14.8992 0 19.2 4.3008 19.2 9.6Z"
            fill="#03C975"
          />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M13.7681 10.5298L13.6045 12.8391L13.6093 12.8438C13.5945 13.0493 13.5068 13.2419 13.3566 13.3921L12.7359 14.0128C12.4656 14.2831 12.0356 14.2935 11.7781 14.0361L10.4509 12.7088L10.0983 12.8313C9.73624 12.9569 9.33419 12.8647 9.0632 12.5937L7.14366 10.6741C6.88393 10.4144 6.7875 10.0332 6.89249 9.6812L7.01443 9.2724L5.64157 7.89954C5.38409 7.64207 5.39455 7.21202 5.66485 6.94172L6.28555 6.32101C6.43072 6.17585 6.62833 6.08314 6.83382 6.06837L9.17641 5.93817L9.36162 5.75296C11.1236 3.99097 14.1432 3.53662 15.154 4.54745C16.1649 5.55829 15.7203 8.57763 13.9533 10.3446L13.7681 10.5298ZM13.3112 8.68192C12.7254 9.26771 11.7757 9.26771 11.1899 8.68192C10.6041 8.09614 10.6041 7.14639 11.1899 6.5606C11.7757 5.97482 12.7254 5.97482 13.3112 6.5606C13.897 7.14639 13.897 8.09614 13.3112 8.68192ZM4.87003 15.2805C5.56308 15.3864 6.91338 15.5927 7.51405 14.992C8.21132 14.2947 8.144 13.0938 7.36392 12.3137C6.58383 11.5336 5.38289 11.4663 4.68563 12.1636C4.14131 12.7079 4.30808 14.2422 4.41166 14.9036C4.44088 15.0857 4.59186 15.2367 4.77402 15.2659C4.80437 15.2705 4.83643 15.2754 4.87003 15.2805Z"
            fill="white"
          />
        </svg>
      )}
    </i>
  );
}

export default BadgeIcon;
